import React from "react";
import { BlockContainer, InnerBlockContainer, ContentContainer } from "BaseComponents/Wrappers";
import { H2 } from "BaseComponents/Text";
import { CTAItem } from "./CTAItem";
export const CTABlock = ({ CTAItems, Heading }) => {
	return (
		<BlockContainer>
			<InnerBlockContainer>
				{!!Heading.length && <H2 textAlign="center">{Heading}</H2>}

				<ContentContainer justifyContent="center" flexWrap="wrap" margin="0 -15px">
					{CTAItems.map((ctaItem, key) => {
						return <CTAItem key={`cta-item-${key}`} {...ctaItem} />;
					})}
				</ContentContainer>
			</InnerBlockContainer>
		</BlockContainer>
	);
};
